module.exports = __webpack_public_path__ + "img/box.d4048b07.png";